import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["headlineWrapper", "swiperPagination"];

  connect() {
    this.adjustSwiperPagination();
    window.addEventListener("resize", this.adjustSwiperPagination.bind(this));
  }

  disconnect() {
    window.removeEventListener(
      "resize",
      this.adjustSwiperPagination.bind(this)
    );
  }

  adjustSwiperPagination() {
    if (
      this.hasHeadlineWrapperTarget &&
      this.swiperPaginationTargets.length > 0
    ) {
      const headlineHeight = this.headlineWrapperTarget.offsetHeight;
      const newBottomValue = headlineHeight + 16; // Add 16px to the height

      this.swiperPaginationTargets.forEach((pagination) => {
        pagination.style.bottom = `${newBottomValue}px`;
      });
    } else {
      console.error("Targets not found: headlineWrapper or swiperPagination");
    }
  }
}
